export default __webpack_public_path__ + "static/pattern3-2418e04dd05ac3b98ee110ec2c75525d.png";